module.exports = __webpack_public_path__ + "static/media/PortfolioCard.5ffa487a.png";